
<div class="modal-dialog confirm-dialog" style="display: flex; justify-content: center;">
  <div class="modal-content" style="min-width:630px;">
    <form #orderForm="ngForm">
      <div class="modal-header">
        <h5 class="modal-title">Convert XLSM to XLSX</h5>
      </div>
    </form>
    <form #orderForm="ngForm">
      <div class="modal-body">
        <label>Step 1 - Open the Macro Enabled Excel file you want to convert. Go over to the 'File' option at the top-left corner of the spreadsheet.</label>
        <label>Step 2 - On the left panel, you will find the option 'Save As'. Click on it. Choose the location where you want to save the file.</label>
        <label>Step 3 - On the pop-up window, you can choose from different formats by clicking on the drop-down menu 'Save as type'. Click on XLSX format.</label>
        <label>Step 4 - After choosing, click on 'Save' to save the XLSX file in the given location.</label>
        <label>Step 5 - Upload the saved file by clicking on 'Upload Partner Installation Form'.</label>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="cancel()">OK</button>
      </div>
    </form>
  </div>
</div>